"use strict";

var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var errors_1 = require("@feathersjs/errors");

var storage_1 = require("./storage");

var getMatch = function getMatch(location, key) {
  var regex = new RegExp("(?:&?)".concat(key, "=([^&]*)"));
  var match = location.hash ? location.hash.match(regex) : null;

  if (match !== null) {
    var _match = _slicedToArray(match, 2),
        value = _match[1];

    return [value, regex];
  }

  return [null, regex];
};

var AuthenticationClient =
/*#__PURE__*/
function () {
  function AuthenticationClient(app, options) {
    _classCallCheck(this, AuthenticationClient);

    var socket = app.io || app.primus;
    var storage = new storage_1.StorageWrapper(app.get('storage') || options.storage);
    this.app = app;
    this.options = options;
    this.authenticated = false;
    this.app.set('storage', storage);

    if (socket) {
      this.handleSocket(socket);
    }
  }

  _createClass(AuthenticationClient, [{
    key: "handleSocket",
    value: function handleSocket(socket) {
      var _this = this;

      // Connection events happen on every reconnect
      var connected = this.app.io ? 'connect' : 'open';
      var disconnected = this.app.io ? 'disconnect' : 'disconnection';
      socket.on(disconnected, function () {
        var authPromise = new Promise(function (resolve) {
          return socket.once(connected, function () {
            return resolve();
          });
        }) // Only reconnect when `reAuthenticate()` or `authenticate()`
        // has been called explicitly first
        // Force reauthentication with the server
        .then(function () {
          return _this.authenticated ? _this.reAuthenticate(true) : null;
        });

        _this.app.set('authentication', authPromise);
      });
    }
  }, {
    key: "getFromLocation",
    value: function getFromLocation(location) {
      var _getMatch = getMatch(location, this.options.locationKey),
          _getMatch2 = _slicedToArray(_getMatch, 2),
          accessToken = _getMatch2[0],
          tokenRegex = _getMatch2[1];

      if (accessToken !== null) {
        location.hash = location.hash.replace(tokenRegex, '');
        return Promise.resolve(accessToken);
      }

      var _getMatch3 = getMatch(location, this.options.locationErrorKey),
          _getMatch4 = _slicedToArray(_getMatch3, 2),
          message = _getMatch4[0],
          errorRegex = _getMatch4[1];

      if (message !== null) {
        location.hash = location.hash.replace(errorRegex, '');
        return Promise.reject(new errors_1.NotAuthenticated(decodeURIComponent(message)));
      }

      return Promise.resolve(null);
    }
  }, {
    key: "setAccessToken",
    value: function setAccessToken(accessToken) {
      return this.storage.setItem(this.options.storageKey, accessToken);
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      var _this2 = this;

      return this.storage.getItem(this.options.storageKey).then(function (accessToken) {
        if (!accessToken && typeof window !== 'undefined' && window.location) {
          return _this2.getFromLocation(window.location);
        }

        return accessToken || null;
      });
    }
  }, {
    key: "removeAccessToken",
    value: function removeAccessToken() {
      return this.storage.removeItem(this.options.storageKey);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.app.set('authentication', null);
      this.authenticated = false;
      return Promise.resolve(null);
    }
  }, {
    key: "handleError",
    value: function handleError(error, type) {
      var _this3 = this;

      if (error.code === 401 || error.code === 403) {
        var promise = this.removeAccessToken().then(function () {
          return _this3.reset();
        });
        return type === 'logout' ? promise : promise.then(function () {
          return Promise.reject(error);
        });
      }

      return Promise.reject(error);
    }
  }, {
    key: "reAuthenticate",
    value: function reAuthenticate() {
      var _this4 = this;

      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // Either returns the authentication state or
      // tries to re-authenticate with the stored JWT and strategy
      var authPromise = this.app.get('authentication');

      if (!authPromise || force === true) {
        return this.getAccessToken().then(function (accessToken) {
          if (!accessToken) {
            throw new errors_1.NotAuthenticated('No accessToken found in storage');
          }

          return _this4.authenticate({
            strategy: _this4.options.jwtStrategy,
            accessToken: accessToken
          });
        });
      }

      return authPromise;
    }
  }, {
    key: "authenticate",
    value: function authenticate(authentication, params) {
      var _this5 = this;

      if (!authentication) {
        return this.reAuthenticate();
      }

      var promise = this.service.create(authentication, params).then(function (authResult) {
        var accessToken = authResult.accessToken;
        _this5.authenticated = true;

        _this5.app.emit('login', authResult);

        _this5.app.emit('authenticated', authResult);

        return _this5.setAccessToken(accessToken).then(function () {
          return authResult;
        });
      }).catch(function (error) {
        return _this5.handleError(error, 'authenticate');
      });
      this.app.set('authentication', promise);
      return promise;
    }
  }, {
    key: "logout",
    value: function logout() {
      var _this6 = this;

      return Promise.resolve(this.app.get('authentication')).then(function () {
        return _this6.service.remove(null).then(function (authResult) {
          return _this6.removeAccessToken().then(function () {
            return _this6.reset();
          }).then(function () {
            _this6.app.emit('logout', authResult);

            return authResult;
          });
        });
      }).catch(function (error) {
        return _this6.handleError(error, 'logout');
      });
    }
  }, {
    key: "service",
    get: function get() {
      return this.app.service(this.options.path);
    }
  }, {
    key: "storage",
    get: function get() {
      return this.app.get('storage');
    }
  }]);

  return AuthenticationClient;
}();

exports.AuthenticationClient = AuthenticationClient;